import { StudyListType } from '@/models/studyListModel'
import { StudyDetailType } from '@/models/studyDetailModel'
import { ApiResponseStudyContent } from '@/models/apiResponses/studyContents'
import {
  ApiResponseOriginalCurriculumInfo,
  ApiResponseOriginalCurriculumUnit,
  ApiOriginalCurriculumUnit,
} from '@/models/apiResponses/originalCurriculums'
import { CommonCharacterSetting } from '@/const/DisplaySettings'

export class StudyManagementUtils {
  /**
   * APIレスポンスをテスト一覧表示用に変換する
   * @param apiResponse テストコンテンツ一覧APIレスポンス
   * @returns テスト一覧
   */
  public static formatStudyLists(apiResponse: ApiResponseStudyContent[]): StudyListType[] {
    if (!apiResponse) return []

    return apiResponse.map((response) => {
      return {
        year: `${response.year}年`,
        month: response.month,
        groups: response.originalCurriculums.map((originalCurriculum) => {
          return {
            title: originalCurriculum.gradeName,
            managementItem: {
              originalCurriculumId: originalCurriculum.id,
            },
          }
        }),
      }
    })
  }

  /**
   * テスト情報詳細のタイトルを生成する
   * @param apiResponse テスト詳細情報APIレスポンス
   * @returns テスト情報詳細のタイトル
   */
  public static buildStudyContentTitle(apiResponse: ApiResponseOriginalCurriculumInfo): string {
    if (!apiResponse) return ''

    return `${apiResponse.studyContentName}${CommonCharacterSetting.TAB_NAME_SEPARATOR}${apiResponse.name}`
  }

  /**
   * テスト詳細情報の一覧を表示用に変換する
   * @param apiResponse テスト詳細一覧APIレスポンス
   * @returns テスト詳細情報の一覧
   */
  public static formatStudyDetailList(apiResponse: ApiResponseOriginalCurriculumUnit[]): StudyDetailType[] {
    if (!apiResponse) return []

    return apiResponse.map((unit) => {
      return {
        id: unit.id,
        subject: unit.subject,
        selection: unit.name,
        numberValue: unit.numberIsSingle !== null ? String(unit.numberIsSingle) : '',
        numberEditDisabled: unit.numberDisabled,
        endConditionValue: unit.endConditionIsTime !== null ? String(unit.endConditionIsTime) : '',
        endConditionEditDisabled: unit.endConditionDisabled,
        period:
          unit.periodStartDate && unit.periodEndDate ? { start: unit.periodStartDate, end: unit.periodEndDate } : null,
        periodEditDisabled: unit.periodDisabled,
        registrationDate: unit.createdAt,
      }
    })
  }

  /**
   * テスト詳細情報の一覧から更新APIに渡すリクエストパラメータを生成する
   * @param list テスト詳細情報の一覧
   * @returns テスト詳細情報更新APIに渡すリクエストパラメータ
   */
  public static buildOriginalCurriculumUnitSettings(list: StudyDetailType[]): ApiOriginalCurriculumUnit[] {
    return list.map((detail) => {
      return {
        id: detail.id,
        numberIsSingle: detail.numberValue !== '' ? detail.numberValue === 'true' : null,
        endConditionIsTime: detail.endConditionValue !== '' ? detail.endConditionValue === 'true' : null,
        periods: detail.period,
      }
    })
  }
}
